export interface IPOState {
    //purchase orders
    getPOIntCodeSuccess: any;
    getPOIntCodeError: any;
    getAllPOSuccess: any;
    getAllPOError: any;
    getPosByStatusIdSuccess: any;
    getPosByStatusIdError: any;
    getAddPOSuccess: any;
    getAddPOError: any;
    getEditPOSuccess: any;
    getEditPOError: any;
    getInActivatePOSuccess: any;
    getInActivatePOError: any;
    getReceiveMaterialCodeSuccess: any;
    getReceiveMaterialCodeError: any;
    getAddReceiveMatSuccess: any;
    getAddReceiveMatError: any;
    getAllReceivedLOTsSuccess: any;
    getAllReceivedLOTsError: any;
    getEditReceivedLOTsSuccess: any;
    getEditReceivedLOTsError: any;
    getPodetailsByIdSuccess: any;
    getPodetailsByIdError: any;
    getVehicleConditionSuccess: any;
    getVehicleConditionError: any;
    getStatusMoveToCompleteSuccess: any;
    getStatusMoveToCompleteError: any;
    getCompletePOSuccess: any;
    getCompletePOError: any;
    getPOsByAgentManuIdSuccess: any;
    getPOsByAgentManuIdError: any;
}
export const initialPOState: IPOState = {
    //purchase orders

    getPOIntCodeSuccess: null,
    getPOIntCodeError: null,
    getAllPOSuccess: null,
    getAllPOError: null,
    getPosByStatusIdSuccess: null,
    getPosByStatusIdError: null,
    getAddPOSuccess: null,
    getAddPOError: null,
    getEditPOSuccess: null,
    getEditPOError: null,
    getInActivatePOSuccess: null,
    getInActivatePOError: null,
    getReceiveMaterialCodeSuccess: null,
    getReceiveMaterialCodeError: null,
    getAddReceiveMatSuccess: null,
    getAddReceiveMatError: null,
    getAllReceivedLOTsSuccess: null,
    getAllReceivedLOTsError: null,
    getEditReceivedLOTsSuccess: null,
    getEditReceivedLOTsError: null,
    getPodetailsByIdSuccess: null,
    getPodetailsByIdError: null,
    getVehicleConditionSuccess: null,
    getVehicleConditionError: null,
    getStatusMoveToCompleteSuccess: null,
    getStatusMoveToCompleteError: null,
    getCompletePOSuccess: null,
    getCompletePOError: null,
    getPOsByAgentManuIdSuccess: null,
    getPOsByAgentManuIdError: null
}

